import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import throttle from 'lodash.throttle';
import withScrollableContainer from '../../decorators/withScrollableContainer';
import TooltipManager from '../TooltipManager';
import TooltipPopper from '../TooltipPopper';
import { ThemeOverride } from '../../Context';
import s from './TextTooltipOnHover.scss';
var SCROLL_THROTTLE_TIMEOUT = 400;
var TextTooltipOnHover = /** @class */ (function (_super) {
    tslib_1.__extends(TextTooltipOnHover, _super);
    function TextTooltipOnHover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isVisible: false,
        };
        _this.attachScrollListener = function () {
            window.addEventListener('wheel', _this.hideTooltipDebounced);
        };
        _this.detachScrollListener = function () {
            window.removeEventListener('wheel', _this.hideTooltipDebounced);
        };
        _this.showTooltip = function () {
            _this.props.hideOnScroll && _this.attachScrollListener();
            if (!_this.state.isVisible) {
                _this.setState({ isVisible: true }, _this.props.onVisible);
            }
        };
        _this.hideTooltip = function () {
            _this.hoverTimerId && clearTimeout(_this.hoverTimerId);
            _this.props.hideOnScroll && _this.detachScrollListener();
            if (_this.state.isVisible) {
                _this.setState({ isVisible: false }, _this.props.onHidden);
            }
        };
        _this.onMouseEnter = function () {
            var _a = _this.props.hoverDelay, hoverDelay = _a === void 0 ? 1 : _a;
            _this.hideTimerId && clearTimeout(_this.hideTimerId);
            _this.hoverTimerId = window.setTimeout(_this.showTooltip, hoverDelay);
        };
        _this.onMouseLeave = function () {
            // a small delay on hiding is needed to handle both tooltip and reneference hovers
            _this.hideTimerId = window.setTimeout(_this.hideTooltip, 100);
        };
        _this.hideTooltipDebounced = throttle(_this.hideTooltip, SCROLL_THROTTLE_TIMEOUT, {
            leading: true,
        });
        return _this;
    }
    TextTooltipOnHover.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, children = _a.children;
        var isVisible = this.state.isVisible;
        return (React.createElement(TooltipManager, { renderReference: function (_a) {
                var ref = _a.ref;
                return (React.createElement("span", { ref: ref, className: classnames(s['children-wrapper'], className), onMouseEnter: _this.onMouseEnter, onMouseLeave: _this.onMouseLeave }, children));
            } }, isVisible && this.renderPopper()));
    };
    TextTooltipOnHover.prototype.renderPopper = function () {
        var _a = this.props, className = _a.className, contentClassName = _a.contentClassName, tooltipText = _a.tooltipText, children = _a.children, forceTheme = _a.forceTheme, hoverDelay = _a.hoverDelay, tooltipProps = tslib_1.__rest(_a, ["className", "contentClassName", "tooltipText", "children", "forceTheme", "hoverDelay"]);
        var isVisible = this.state.isVisible;
        var popper = (React.createElement(TooltipPopper, tslib_1.__assign({}, tooltipProps, { eventsEnabled: isVisible, className: classnames(s['tooltip'], isVisible && s['visible']), contentClassName: contentClassName, onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave, modifiers: { preventOverflow: { boundariesElement: 'window' } }, usePortal: true }), tooltipText));
        return forceTheme ? (React.createElement(ThemeOverride, { theme: forceTheme }, popper)) : (popper);
    };
    TextTooltipOnHover.defaultProps = {
        hideOnScroll: true,
    };
    return TextTooltipOnHover;
}(React.Component));
export { TextTooltipOnHover };
export default withScrollableContainer(TextTooltipOnHover);
//# sourceMappingURL=TextTooltipOnHover.js.map